import { service } from '@/utils/request'

export default {
	getList (data) {
		return service({
			url: '/cloud/uac/admin/doctorInfoData/pages',
			method: 'post',
			data
		})
	},
    // 导出数据
	exportExcel(data) {		
		return service({
			url: '/cloud/uac/admin/doctorInfoData/exportExcel',
			method: 'post',
			data,
			responseType: 'blob'
		})
	}
}


// WEBPACK FOOTER //
// ./src/api/databaseAnlysis/userbasedata.js